module.exports = __webpack_public_path__ + "img/img_product10.13acbe08.jpg";